import React from "react";
import { Link } from "gatsby";

import Footer from "../components/Footer";
import Header from "../components/Header";
import Seo from "../components/Seo";
import "../../scss/main.scss";

export default function EditorialPolicy() {
	return (
		<div className="container edyn-commercial-shell legal-page">
			<Seo
				title="Editorial Standards for Care Advice | Edyn Care"
				description="How Edyn Care creates, checks and updates practical care guidance, including authorship, sources, corrections and professional advice."
				path="/editorial-policy/"
				breadcrumbs={[
					{ name: "Home", path: "/" },
					{ name: "Editorial standards", path: "/editorial-policy/" },
				]}
			/>
			<Header />
			<main id="main-content" className="site-shell legal-page__content">
				<p className="eyebrow">Edyn advice</p>
				<h1>How we create and maintain our care guidance.</h1>
				<p>
					Our articles are written to help families understand care options and
					prepare useful questions. They do not replace individual medical,
					legal or financial advice.
				</p>

				<h2>Named and accountable authors</h2>
				<p>
					Every guide identifies its author and their role. Authors draw on
					Edyn's experience arranging and managing live-in care, and should make
					clear when a subject requires a regulated professional.
				</p>

				<h2>Reliable sources</h2>
				<p>
					For health, public funding, safeguarding and legal topics, we prioritise
					primary guidance from organisations such as the NHS, GOV.UK, NICE and
					the Care Quality Commission. Sources should support the claim beside
					which they appear and be checked when an article is reviewed.
				</p>

				<h2>Review dates and corrections</h2>
				<p>
					Articles display publication and update dates. We review sensitive
					guidance when official advice or Edyn's service changes, and correct
					material errors as soon as they are identified.
				</p>

				<h2>Questions or corrections</h2>
				<p>
					If something appears unclear or out of date, email{" "}
					<a href="mailto:hello@edyn.care">hello@edyn.care</a>. For help with a
					particular care situation, <Link to="/care-consultation/">talk to a
					Care Advisor</Link>.
				</p>
			</main>
			<Footer />
		</div>
	);
}
